import { useIonViewDidEnter, useIonViewWillEnter } from "@ionic/react";

export function useViewDidEnter(fetchFn: () => void, deps?: any[]): void {
  useIonViewDidEnter(fetchFn, deps);
}

export function useViewWillEnter(fetchFn: () => void, deps?: any[]): void {
  useIonViewWillEnter(fetchFn, deps);
}
